import { Button } from 'antd';
import React from 'react';
import Icon from '@ant-design/icons';
import { MetamaskIcon } from '../Icons/index';
import { useOmsWeb3 } from '../../hooks/UseOmsWeb3';

interface WalletInjectLoginProps {
  onSuccess?: (flatSig: string) => void;
  type?: 'default' | 'link';
}

export default (_prop: WalletInjectLoginProps) => {
  const {connect} = useOmsWeb3();
  const {onSuccess, type} = _prop;

  const linkWallet = async () => {
    console.log('Connect by Injected');
    const topic = connect('injected');
    PubSub.subscribe(topic, (msg, res) => {
      if (res?.data) {
        console.log('flatSig', res.data);
        onSuccess?.(res.data.toString());
      }
      PubSub.unsubscribe(topic);
    });
  };

  const style = type === 'link' ? {} : {width: '100%'}

  return <>
    <Button icon={<Icon component={MetamaskIcon}/>} type={type === 'link' && 'link' || 'dashed'} style={style}
            onClick={linkWallet}
            size={'large'}>Metamask</Button>
  </>
}
